// extracted by mini-css-extract-plugin
export default {"container":"select_container__Ew1jB","error":"select_error__6ZGkt"};